import script from "./productVariation.vue?vue&type=script&lang=ts&setup=true"
export * from "./productVariation.vue?vue&type=script&lang=ts&setup=true"

import "./productVariation.vue?vue&type=style&index=0&id=5c5eb87e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5eb87e"]])

export default __exports__